/**
 * Standalone page for Plan Guide Widget.
 * AI-powered wizard for understanding and improving financial plans.
 *
 * @see frontend/workspace/CU-868gzzjua/frontend_research.md
 * @see frontend/workspace/CU-868gzzjua/frontend_implementation_guide.md
 */

import React from "react";
import { Box, Typography } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { PlanGuideWidget } from "@app/features/planGuide";

export const PlanGuidePage: React.FC = () => {
  const { planResultRootId, planResultTypeId } = useParams<{
    planResultRootId: string;
    planResultTypeId: string;
  }>();
  const navigate = useNavigate();

  if (!planResultRootId || !planResultTypeId) {
    return (
      <Box sx={{ p: 3 }}>
        <Typography variant="par02Regular">
          Missing required parameters: planResultRootId and planResultTypeId
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        width: "100vw",
        height: "100vh",
        position: "relative",
        overflow: "hidden",
      }}
    >
      <PlanGuideWidget
        planResultRootId={planResultRootId}
        planResultTypeId={planResultTypeId}
        onComplete={() => {
          // Navigate back to workbench or show completion
          navigate(-1);
        }}
        onClose={() => navigate(-1)}
      />
    </Box>
  );
};
